// extracted by mini-css-extract-plugin
module.exports = {"container":"loader_with_text-module__container--1WhY9","text":"loader_with_text-module__text--U8SFk"};